export class RequestRecuperarChaveAcesso {

    private documento: string;
    private recaptchaChallenge: string;

    public getDocumento(): string {
        return this.documento;
    }

    public setDocumento(documento: string): void {
        this.documento = documento;
    }

    public getRecaptchaChallenge(): string {
        return this.recaptchaChallenge;
    }

    public setRecaptchaChallenge(recaptchaChallenge: string): void {
        this.recaptchaChallenge = recaptchaChallenge;
    }

}



// WEBPACK FOOTER //
// ./src/app/resources/classes/request-recuperar-chave-acesso.ts